import {BaseWidget} from "./BaseWidget";
import {isTextToEmailLinkField, isTextToLinkField, isTextToPhoneNumberLinkField} from "../login/ClientCache";
import * as ft from "../constants/FieldType";
import PhoneFieldTemplate from "../compiled-templates/PhoneFieldTemplate";
import MapLocationTemplate from "../compiled-templates/MapLocationTemplate";
import * as ts from "../common/Translator";
import {updateValueInWidget} from "../actions/BaseDispatcher";
import {EditPresenter} from "../routing/EditPresenter";
import EmailFieldTemplate from "../compiled-templates/EmailFieldTemplate";
import LinkFieldTemplate from "../compiled-templates/LinkFieldTemplate";

export class TextFieldWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        this.findElement().addClass("k-textbox");
        let linkGoTo = this.owner.rootElement().find("#" + this.elementId + "linkGoTo");
        if (linkGoTo && linkGoTo.length)
            linkGoTo.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val && !val.contains("//") && !val.toLowerCase().startsWith("tel:"))
                    val = "//" + val;
                window.open(val, "_blank");
            });
        let linkWhatsapp = this.owner.rootElement().find("#" + this.elementId + "linkwhatsapp");
        if (linkWhatsapp && linkWhatsapp.length)
            linkWhatsapp.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val)
                    window.open('https://wa.me/' + val, "_blank");
            });
        let linkCall = this.owner.rootElement().find("#" + this.elementId + "linkcall");
        if (linkCall && linkCall.length)
            linkCall.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val)
                    window.open('tel:' + val, "_blank");
            });
        let linkEmail = this.owner.rootElement().find("#" + this.elementId + "linkemail");
        if (linkEmail && linkEmail.length)
            linkEmail.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val)
                    window.open('mailto:' + val, "_blank");
            });
        let linkLatLng = this.owner.rootElement().find("#" + this.elementId + "linkLatLng");
        if (linkLatLng && linkLatLng.length) {
            linkLatLng.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                window.open("locpicker.html?q=" + (val || ""), "locationPicker", "height=800,width=900");
                window.lastLocationPickerField = this;
            });
        }
    }

    setEnabled(enabled) {
        super.setEnabled(enabled);
        if (this.owner) {
            let latLng = this.owner.rootElement().find("#" + this.elementId + "linkLatLng");
            if (enabled === "Enabled" || enabled === true)
                latLng.removeClass("k-disabled");
            else
                latLng.addClass("k-disabled");
        }
    }

    onLocationPicked(selectedLocation, address) {
        let that = this;
        let fieldId = that.id;
        that.findElement().val(selectedLocation);
        that.onEdit(selectedLocation);
        window.lastLocationPickerField = null;

        let owner = that.owner;
        if (!owner)
            return;
        if (owner.onDataChanged) {
            let address2Id = fieldId.replace(".mapLocation", ".address2");
            owner.onDataChanged(address2Id, address, that.cellOptions, that.entityType);
            if (owner instanceof EditPresenter)
                updateValueInWidget(owner, address2Id, address);
        }
    }

    createElement(style) {
        let that = this;
        if (isTextToPhoneNumberLinkField(that.id, that.owner.entityType) || that.fieldMetadata.fieldType == ft.PhoneNumber)
            return $(PhoneFieldTemplate({elementId: that.elementId, translateId: ts.translateId, style: style, id: this.id}));
        if (isTextToEmailLinkField(that.id, that.owner.entityType) || that.fieldMetadata.fieldType == ft.Email)
            return $(EmailFieldTemplate({elementId: that.elementId, translateId: ts.translateId, style: style, id: this.id}));
        if (isTextToLinkField(that.id, that.owner.entityType) || that.fieldMetadata.fieldType == ft.Link)
            return $(LinkFieldTemplate({elementId: that.elementId, translateId: ts.translateId, style: style, id: this.id}));
        if (that.fieldMetadata.fieldType == ft.LatLng)
            return $(MapLocationTemplate({elementId: that.elementId, translateId: ts.translateId}));
        return $(`<input class="w-100" autocomplete="off"  type='text' ${style} id="${this.elementId}" nid="${this.id}">`);

    }
}